import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { UserLoginRequestModel } from '../../model/request/user-login.request.model';
import { UserViewModel } from '../../model/view-model/user/user.view.model';
import { AuthStateService } from '../../state/auth.state.service';
import { Injectable } from '@angular/core';
import { UserDataProvider } from '../../data-provider/user.data-provider';
import { PersonalModel } from '../../model/personal.model';
import { UserApiModel } from '../../model/api-model/user/user.api.model';
import { RegisterClientRequest } from '../../model/request/register-client.request.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private userDataProvider: UserDataProvider, private authStateService: AuthStateService) {}

  createAccountIfNeeded(formValues: any, requiresAccount: boolean): Observable<UserViewModel | null> {
    if (!requiresAccount || this.authStateService.isLogged()) {
      return of(null);
    }

    const agreements = formValues.agreements || [];
    const user: UserViewModel = new UserViewModel({
      ...formValues,
      plainPassword: formValues.registerAccountPassword,
      agreements: agreements.filter((a: any) => a?.checked).map((a: any) => a.id)
    });

    return this.userDataProvider.create(user);
  }

  loginAfterRegistration(user: UserViewModel, password: string): Observable<any> {
    return this.authStateService.login({
      username: user.email,
      password: password
    } as UserLoginRequestModel);
  }

  updateAgreements(value: PersonalModel, checkedAgreements: string[]) {
    const token = this.authStateService.getToken();
    if (!token) {
      return of(null);
    }

    const user = Object.assign(new UserApiModel(), {
      ...this.authStateService.getUser(),
      phone: value.phone,
      token
    });

    if (checkedAgreements.length) {
      user.agreements = [...checkedAgreements];
      return this.userDataProvider.update(user, user.token).pipe(tap((user) => this.authStateService.setUser(user.toApiModel())));
    }

    return of(null);
  }

  registerInSynerise(value: PersonalModel, checkedAgreements: string[], projectName: string): Observable<any> {
    if (!projectName) {
      return of(null);
    }

    const registerClient: RegisterClientRequest = {
      email: value.email,
      phone: value.phone,
      firstName: value.firstName,
      lastName: value.lastName,
      agreements: checkedAgreements
    };

    return this.userDataProvider.registerClientInSynerise(projectName, registerClient).pipe(
      catchError((error) => {
        console.error('Error during register in synerise:', error);
        return of(null);
      })
    );
  }
}
